import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { ddStyles } from "../utils/CommonStyles.js";
import FetchUtil from "../utils/FetchUtil";

function DelegateProductTableRow({ index, selectedDelegate, primaryBuyerCompanyId, secondaryBuyerCompanyId, delegateProductItem, handleSubmit, setError, t, setAdd, oddIdx }) {
    const navigate = useNavigate();
    const [supplierKey, setSupplierKey] = useState(selectedDelegate.companyId);
    const [delegateKey, setDelegateKey] = useState(selectedDelegate.delegateKey);
    const [isSubmit, setIsSubmit] = useState(false);
    const [products, setProducts] = useState([]);
    const [productOptions, setProductOptions] = useState([]);
    const [productKey, setProductKey] = useState(0);
    const [productLoaded, setProductLoaded] = useState(false);
    const [productSelected, setProductSelected] = useState({ name: "productKey", label: "", value: 0 });

    useEffect(() => {
        fetchProducts(selectedDelegate.companyId, selectedDelegate.parentCompanyKey);
    }, []);

    function fetchProducts(selectedSupplierKey, parentCompanyKey) {
        setError("");
        let buyerCompanyId = (parentCompanyKey && parentCompanyKey != '0') ? parentCompanyKey : primaryBuyerCompanyId;
        if (!selectedSupplierKey || selectedSupplierKey === 0 || !buyerCompanyId) {
            return;
        }
        setProducts([]);
        setProductKey(0);
        setProductOptions([]);
        setProductSelected({ ...productSelected, label: "", value: 0 });
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                source: "web", getAll: false,
                supplierKey: selectedSupplierKey,
                buyerKey: buyerCompanyId,
				includeInactivePartner: true
            }),
        };
        try {
            FetchUtil.fetchAPI("GetPartnerProducts", "/Service/CompanyService/GetPartnerProducts", requestOptions, retrieveProductSuccess, retrieveProductFail);
        } catch (error) {
            throw new Error(error.message);
        }
    }

    function retrieveProductFail(redirect) {
        if (redirect) {
            navigate("/");
        }
        setError(t("error.getProdFailed"));
    }

    function retrieveProductSuccess(responseData) {
        let getPartnerProductResponse;
        if (responseData) {
            getPartnerProductResponse = responseData.getPartnerProductResponse;
            if (getPartnerProductResponse && getPartnerProductResponse.errorCode === "0") {
                setProductValues(getPartnerProductResponse.products);
                if (getPartnerProductResponse.products) {
                    setProducts(getPartnerProductResponse.products.slice());
                }
            } else if (getPartnerProductResponse && getPartnerProductResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (getPartnerProductResponse) {
                setError(t("error.error") + " " + getPartnerProductResponse.errorMessage);
            } else {
                setError(t("error.system.fetch"));
            }
        }
    }
    function setProductValues(products) {
        let productValue = {};
        let selectedProductId = 0;
        let selectedProductName = "";
        if ((delegateProductItem && Object.keys(delegateProductItem).length > 0)) {
            selectedProductId = delegateProductItem.productKey;
        }
        let productOptionList = [];
        productOptionList.push({ label: "", value: 0 });
        if (products && products.length > 0) {
            products.map((aProduct, idx) => {
				if(aProduct.partnerKey != secondaryBuyerCompanyId){
					productValue.label = aProduct.commodityName + ", " + aProduct.productName + (aProduct.productSku ? (", " + aProduct.productSku) : "");
	                productValue.value = aProduct.companyProductKey;
	                productOptionList.push(productValue);
	                productValue = {};
				}
                if (aProduct.companyProductKey == selectedProductId) {
                    selectedProductName = aProduct.commodityName + ", " + aProduct.productName + (aProduct.productSku ? (", " + aProduct.productSku) : "");
                }
            });
        }
        setProductOptions(productOptionList);
        setProductLoaded(true);
        if (selectedProductName !== "") {
            setProductSelected({ ...productSelected, label: selectedProductName, value: selectedProductId });
            setProductKey(selectedProductId);
        } else {
            setProductSelected({ ...productSelected, label: "", value: 0 });
            setProductKey(0);
        }
    }
    const productHandler = (selectedOption) => {
        let selectedProductKey = selectedOption ? selectedOption.value : 0;
        let selectedProductName = selectedOption ? selectedOption.label : "";

        setProductKey(selectedProductKey);
        setProductSelected({ ...productSelected, label: selectedProductName, value: selectedProductKey });
    }
    function submitComplete() {
        setIsSubmit(false);
    }
    function submitRow() {
        setError("");
        setIsSubmit(true);
        let action = 1;
        let delegateProductKey = 0;
        let editDelegateKey = delegateKey;
        if ((delegateProductItem && Object.keys(delegateProductItem).length > 0)) {
            action = 2;
            delegateProductKey = delegateProductItem.delegateProductKey;
            if (editDelegateKey == 0) {
                editDelegateKey = delegateProductItem.delegateKey;
            }
        }
        if (!supplierKey || supplierKey === 0) {
            setError(t("error.supplier.Reqd"));
            setIsSubmit(false);
        } else if (!productKey || productKey === 0) {
            setError(t("error.prod.Reqd"));
            setIsSubmit(false);
        } else {
            let initialValues = {
                delegateProductKey: delegateProductKey,
                companyKey: supplierKey,
                productKey: productKey,
                action: action,
                delegateKey: editDelegateKey,
            };
            handleSubmit(action, initialValues, submitComplete);
        }

    }
    function submitCancel() {
        setError("");
        setAdd(false);
        setIsSubmit(false);
    }
    return (
        <tr key={index}>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                 {selectedDelegate ? 
                	((selectedDelegate.parentCompanyName && selectedDelegate.parentCompanyName != "") ? 
                		selectedDelegate.parentCompanyName + " <- " : "") + selectedDelegate.companyName : delegateProductItem.companyName}
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                {productLoaded ? <Select
                    name="productKey"
                    options={productOptions}
                    onChange={productHandler}
                    placeholder={""}
                    value={productSelected}
                    isSearchable={true}
                    isClearable={true}
                    className="myselect"
                    inputId="productKey-input"
                    styles={ddStyles}
                />
                    : <></>}
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}></td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{t("page.active")}</td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                <div id="submit-spinner"
                    className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
                >
                </div>
                <button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>
                <button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitCancel())}>{t("page.cancel")}</button></td>
        </tr>
    )

}
export default DelegateProductTableRow;